// @ts-nocheck
import React, { useCallback } from 'react';
import {
  FormControl,
  FormControlLabel,
  Checkbox,
  FormLabel,
} from '@mui/material';
import PropTypes from 'prop-types';

/**
 * Checkbox field component for editing boolean attributes
 * @param {Object} props - Component props
 * @param {string} props.label - Field label
 * @param {boolean} props.value - Current field value
 * @param {Function} props.onChange - Function to handle value changes
 * @param {Object} props.attribute - The attribute being edited
 * @returns {React.ReactElement} The Checkbox component
 */
const CheckboxFieldComponent = ({ label, value, onChange, attribute }) => {
  /**
   * Handles checkbox change events
   * @function
   * @param {React.ChangeEvent<HTMLInputElement>} e - The change event
   * @returns {void}
   */
  const handleChange = useCallback(
    (e) => {
      onChange(e?.target?.checked);
    },
    [onChange]
  );

  return (
    <FormControl fullWidth>
      <FormLabel component="legend">{label}</FormLabel>
      <FormControlLabel
        control={
          <Checkbox
            checked={!!value}
            onChange={handleChange}
            name={attribute?.name || ''}
          />
        }
        label={label}
      />
    </FormControl>
  );
};

CheckboxFieldComponent.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  attribute: PropTypes.shape({
    name: PropTypes.string,
    data_type: PropTypes.string,
  }).isRequired,
};

export default CheckboxFieldComponent;
